import React from 'react';
import { Outlet } from 'react-router';
import { Watermark } from '@link/share/components';

import { isProd } from '@link/china-railway/utils';

import styles from './base.module.css';

const BaseLayout: React.FC = () => {
  return (
    <div className={styles.base}>
      <main className={styles.main}>
        <Outlet />
      </main>
      {!isProd && <Watermark />}
    </div>
  );
};

export default BaseLayout;
